import { createMutationHook, collapseDataFromCall, collapseParams } from '../../client';
import { createOrderV2, getTermsAndConditions, getOffersV2 } from '../../services/smartthermostat/SalesV2Service';

export const useSalesV2CreateOrderV2 = createMutationHook(
  collapseDataFromCall(
    collapseParams(
      collapseParams(createOrderV2, 'requestBody', 'data'),
      'data',
      'offerIds',
      'referenceId',
      'deliveryAddress',
    ),
  ),
  {
    injectables: ['label', 'customerId', 'accountId', 'businessUnit'],
    flattenData: true,
    flattenBodyPairs: [
      { target: 'requestBody', props: ['data'] },
      { target: 'data', props: ['offerIds', 'referenceId', 'deliveryAddress'] },
    ],
  },
);

export const useSalesV2GetTermsAndConditions = createMutationHook(
  collapseDataFromCall(
    collapseParams(collapseParams(getTermsAndConditions, 'requestBody', 'data'), 'data', 'offerIds'),
  ),
  {
    injectables: ['label', 'customerId', 'accountId', 'businessUnit'],
    flattenData: true,
    flattenBodyPairs: [
      { target: 'requestBody', props: ['data'] },
      { target: 'data', props: ['offerIds'] },
    ],
  },
);

export const useSalesV2GetOffersV2 = createMutationHook(
  collapseDataFromCall(
    collapseParams(collapseParams(getOffersV2, 'requestBody', 'data'), 'data', 'offerTypes', 'includeAdditionalOffers'),
  ),
  {
    injectables: ['label', 'customerId', 'accountId', 'businessUnit'],
    flattenData: true,
    flattenBodyPairs: [
      { target: 'requestBody', props: ['data'] },
      { target: 'data', props: ['offerTypes', 'includeAdditionalOffers'] },
    ],
  },
);
